import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";
import { DataExportJob, DataExportWorker } from "../types/DataExportJob";

class DataExportService {
    async generateDataExport(clientId: number, corporateSiteName: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/${corporateSiteName}/${clientId}/generatedataexport`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    async getDataExportStatus(taskId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/getdataexportstatus?` +
            `taskId=${encodeURIComponent(taskId)}`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    async getDataExports(): Promise<DataExportJob[]> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    async getDataExportWorkers(): Promise<DataExportWorker[]> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/workers`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    async cancelDataExport(taskId: string): Promise<void> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/${taskId}/cancel`;
        let response = await getAuthenticatedFetch()(url, {method: 'POST'});

        if (response.status === 409) {
            throw new Error('This export has already finished.');
        }

        if (!response.ok) {
            throw new Error('Could not cancel this export.');
        }
    }

    async deleteDataExport(taskId: string): Promise<void> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/${taskId}`;
        let response = await getAuthenticatedFetch()(url, {method: 'DELETE'});

        if (response.status === 409) {
            throw new Error('Cancel this export before deleting it.');
        }

        if (!response.ok) {
            throw new Error('Could not delete this export.');
        }
    }

    /**
     * The API signs a short lived link per click so that the download is recorded in the privileged
     * action log, and the browser then downloads straight from storage.
     */
    async getDataExportDownloadUrl(taskId: string): Promise<string> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DataExport/${taskId}/downloadurl`;
        let response = await getAuthenticatedFetch()(url);

        if (response.status === 410) {
            throw new Error('The export file has been cleaned up and is no longer available to download.');
        }

        if (!response.ok) {
            throw new Error('Could not get a download link for this export.');
        }

        return await response.text();
    }
}

export default new DataExportService();
